// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Canonical marketing chrome.
 *
 * This file is consumed by the Vue app and copied to front/dist by
 * scripts/sync_marketing_chrome.mjs for every generated marketing page.
 * Page-family styles may add content styles, but must not redefine the
 * header, footer, account menu, or shared navigation layout here.
 */

@font-face {
  font-family: "Sharewell Glacial";
  src: url("/fonts/GlacialIndifference.woff") format("woff");
  font-display: optional;
}

/*
 * Optional avoids moving the first viewport when a webfont arrives after the
 * initial paint. These local-only faces keep fallback metrics close when the
 * font is available immediately.
 */
@font-face {
  font-family: "Sharewell Glacial Fallback";
  src: local("Avenir Next"), local("Helvetica Neue"), local("Arial");
  font-style: normal;
  font-weight: 400;
  font-display: optional;
  size-adjust: 95.4%;
  ascent-override: 93.75%;
  descent-override: 25%;
  line-gap-override: 0%;
}

@font-face {
  font-family: "Sharewell Glacial Fallback";
  src: local("Avenir Next"), local("Helvetica Neue"), local("Arial");
  font-style: normal;
  font-weight: 700 900;
  font-display: optional;
  size-adjust: 89.4%;
  ascent-override: 93.75%;
  descent-override: 25%;
  line-gap-override: 0%;
}

@font-face {
  font-family: "Sharewell Display Fallback";
  src: local("Georgia");
  font-style: normal;
  font-weight: 400;
  font-display: optional;
  size-adjust: 100%;
  ascent-override: 103%;
  descent-override: 33%;
  line-gap-override: 0%;
}

@font-face {
  font-family: "Sharewell Hand Fallback";
  src: local("Bradley Hand"), local("Comic Sans MS"), local("cursive");
  font-style: normal;
  font-weight: 400;
  font-display: optional;
  size-adjust: 84%;
  ascent-override: 106%;
  descent-override: 31%;
  line-gap-override: 0%;
}

:root {
  --marketing-body: "Sharewell Glacial", "Sharewell Glacial Fallback", "Avenir Next", "Helvetica Neue", Arial, sans-serif;
  --marketing-display: "DM Serif Text", "Sharewell Display Fallback", Georgia, serif;
  --marketing-hand: "Patrick Hand", "Sharewell Hand Fallback", "Bradley Hand", "Comic Sans MS", cursive;
  --body: var(--marketing-body);
  --display: var(--marketing-display);
  --hand: var(--marketing-hand);
  --faq-body: var(--marketing-body);
  --faq-display: var(--marketing-display);
  --sans: var(--marketing-body);
}

html {
  scroll-behavior: smooth;
}

img {
  display: block;
  max-width: 100%;
}

.skip-link {
  position: fixed;
  top: 0.75rem;
  left: 0.75rem;
  z-index: 30;
  padding: 0.7rem 1rem;
  border-radius: 999px;
  color: #fff;
  background: #29262f;
  transform: translateY(-160%);
  transition: transform 180ms ease;
}

.skip-link:focus {
  transform: translateY(0);
}

.home-shell {
  width: min(1260px, calc(100% - 48px));
  margin-inline: auto;
}

.mock-header {
  --marketing-ink: #302a27;
  --marketing-ink-soft: #6c6159;
  --marketing-paper: #fffaf3;
  --marketing-line: rgba(87, 65, 52, 0.16);
  --marketing-coral: #e75a62;
  --marketing-coral-dark: #d64b55;
  position: relative;
  z-index: 10;
  display: flow-root;
  overflow: visible;
  color: var(--marketing-ink);
  font-family: var(--marketing-body);
}

/*
 * The header is navigation chrome only. Hero and page sections own their
 * visual surfaces, so no shared pseudo-layer can wash over a page title.
 */
.mock-header::before,
.mock-header::after {
  display: none;
  content: none;
  pointer-events: none;
}

/* Guide heroes also own the first-viewport artwork; keep chrome over it. */
.guide-page > .mock-header {
  position: absolute;
  inset: 0 0 auto;
  z-index: 10;
  background: transparent;
}

/*
 * Keep image-led heroes vivid on the illustration side, but give the copy a
 * deliberate cream reading zone. The header remains transparent over the same
 * image, so the surface still reads as one continuous scene.
 */
.guide-page .hero-art::before,
.landing-page .hero-art::before,
.occasion-page .hero::before {
  background:
    linear-gradient(90deg, rgba(255, 253, 248, 0.84) 0%, rgba(255, 253, 248, 0.74) 20%, rgba(255, 253, 248, 0.50) 38%, rgba(255, 253, 248, 0.22) 58%, rgba(255, 253, 248, 0.05) 76%, rgba(255, 253, 248, 0) 92%),
    linear-gradient(180deg, rgba(232, 247, 248, 0.16) 0%, rgba(255, 253, 248, 0) 45%, rgba(255, 253, 248, 0.18) 100%) !important;
}

/* The directory keeps the lighter treatment used by the reference hero. */
.occasion-directory-page .hero::before {
  background:
    linear-gradient(90deg, rgba(255, 253, 248, 0.64) 0%, rgba(255, 253, 248, 0.58) 20%, rgba(255, 253, 248, 0.42) 38%, rgba(255, 253, 248, 0.20) 58%, rgba(255, 253, 248, 0.06) 74%, rgba(255, 253, 248, 0) 90%),
    linear-gradient(180deg, rgba(232, 247, 248, 0.14) 0%, rgba(255, 253, 248, 0) 45%, rgba(255, 253, 248, 0.16) 100%) !important;
}

/* Example pages use a pastel stage instead of a full-bleed hero image. Keep
 * that stage airy, but let the blue-to-peach color carry more presence. */
.evidence-page .hero {
  background:
    radial-gradient(circle at 82% 12%, rgba(255, 255, 255, 0.66) 0 8%, transparent 22%),
    radial-gradient(circle at 12% 36%, rgba(255, 255, 255, 0.44) 0 8%, transparent 24%),
    linear-gradient(145deg, #d1e9e9 0%, #e5f1ed 54%, #f4ccb6 100%);
}

@media (max-width: 760px) {
  .guide-page .hero-art::before,
  .landing-page .hero-art::before,
  .occasion-page .hero::before {
    background: linear-gradient(180deg, rgba(255, 253, 248, 0.58) 0%, rgba(255, 253, 248, 0.48) 29%, rgba(255, 253, 248, 0.28) 58%, rgba(255, 253, 248, 0.38) 100%) !important;
  }

  .occasion-directory-page .hero::before {
    background: linear-gradient(180deg, rgba(255, 253, 248, 0.50) 0%, rgba(255, 253, 248, 0.42) 29%, rgba(255, 253, 248, 0.24) 58%, rgba(255, 253, 248, 0.34) 100%) !important;
  }
}

/* The promotion guide keeps a soft full-bleed reading wash in landscape.
 * It avoids a separate panel over the illustration while preserving enough
 * contrast for the longer French heading on a short viewport. */
@media (max-width: 930px) and (orientation: landscape) {
  .promotion-guide-page > .mock-header .mock-nav {
    margin-top: 10px;
    padding-bottom: 4px;
  }

  .promotion-guide-page > .mock-header .mock-logo,
  .promotion-guide-page > .mock-header .mock-logo img {
    width: clamp(142px, 23vw, 164px);
  }

  .promotion-guide-page > .mock-header .mock-mobile-menu-toggle {
    width: 38px;
    height: 38px;
    border-radius: 12px;
    font-size: 1.4rem;
  }

  .promotion-guide-page .hero-art::before {
    background:
      linear-gradient(90deg, rgba(255, 253, 248, 0.98) 0%, rgba(255, 253, 248, 0.93) 38%, rgba(255, 253, 248, 0.74) 57%, rgba(255, 253, 248, 0.28) 78%, rgba(255, 253, 248, 0) 100%),
      linear-gradient(180deg, rgba(232, 247, 248, 0.2) 0%, rgba(255, 253, 248, 0) 56%, rgba(255, 253, 248, 0.42) 100%) !important;
  }
}

/*
 * The homepage already owns the continuous paper surface behind its hero.
 * Remove the legacy header fade so it cannot wash over the H1 or draw a seam
 * between the navigation and the first hero row.
 */
.homepage-mockup .mock-header::after {
  display: none;
}

.homepage-mockup .mock-header::before {
  display: none;
}

/* Carry the hero's warm sky-to-paper wash from the header into the first row. */
.homepage-mockup {
  background:
    linear-gradient(90deg, rgba(47, 42, 40, 0.035) 1px, transparent 1px) 0 0 / 44px 44px repeat,
    linear-gradient(180deg, rgba(47, 42, 40, 0.03) 1px, transparent 1px) 0 0 / 44px 44px repeat,
    radial-gradient(ellipse at 72% 18%, rgba(255, 255, 255, 0.72) 0 12%, transparent 31%) 0 0 / 100% 360px no-repeat,
    radial-gradient(ellipse at 88% 34%, rgba(255, 255, 255, 0.58) 0 10%, transparent 28%) 0 0 / 100% 360px no-repeat,
    radial-gradient(ellipse at 13% 28%, rgba(255, 255, 255, 0.5) 0 9%, transparent 26%) 0 0 / 100% 360px no-repeat,
    linear-gradient(180deg, #d8eeef 0%, #eef8f5 46%, var(--paper, #fff8f0) 100%) 0 0 / 100% 360px no-repeat,
    var(--paper, #fff8f0);
}

.homepage-mockup .mock-header {
  background: transparent;
}

/*
 * The occasions directory owns the artwork for its first viewport. The
 * shared sky layer must stay out of that artwork, otherwise it washes over
 * the first heading and creates a visible header-to-hero seam.
 */
.occasion-directory-page .mock-header::before {
  display: none;
}

.occasion-directory-page .mock-header {
  background: transparent;
}


.mock-nav {
  position: relative;
  z-index: 3;
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr) auto;
  align-items: center;
  min-height: 64px;
  gap: 24px;
  margin-top: 24px;
  padding: 0;
}

.mock-account-area {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 154px;
}

.mock-mobile-menu-toggle,
.mock-mobile-menu {
  display: none;
}

.mock-brand {
  display: grid;
  width: fit-content;
  justify-items: center;
  gap: 4px;
}

.mock-logo {
  display: inline-flex;
  width: 198px;
  align-items: center;
}

.mock-logo img {
  width: 198px;
  height: auto;
}

.mock-tagline {
  margin: 0;
  color: var(--marketing-coral-dark);
  font-size: 0.66rem;
  font-weight: 800;
  line-height: 1.15;
  text-align: center;
  text-transform: uppercase;
}

.mock-nav-links,
.mock-auth,
.mock-social {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.mock-nav-links {
  justify-content: center;
  gap: clamp(18px, 3vw, 36px);
  color: var(--marketing-ink-soft);
  font-size: 0.9rem;
  font-weight: 700;
}

.mock-auth {
  justify-content: flex-end;
  gap: 10px;
}

.mock-nav a,
.mock-footer a {
  color: inherit;
  text-decoration: none;
  transition: color 220ms ease, background-color 220ms ease, border-color 220ms ease, transform 220ms ease;
}

.mock-nav-links a:hover,
.mock-auth a:hover,
.mock-footer a:hover {
  color: var(--marketing-ink);
  transform: translateY(-1px);
}

.mock-auth a {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  border-radius: 14px;
  font-weight: 800;
  white-space: nowrap;
}

.mock-auth .mock-signup {
  border: 1px solid var(--marketing-coral);
  color: #fffdf7;
  background: var(--marketing-coral);
}

.mock-auth .mock-signup:hover {
  border-color: var(--marketing-coral-dark);
  color: #fffdf7;
  background: var(--marketing-coral-dark);
}

.mock-header .user-dropdown {
  position: relative;
  z-index: 20;
}

/* Reserve the signed-out/signed-in width so auth hydration cannot move the nav. */
.mock-header .mock-auth,
.mock-header .user-dropdown {
  min-width: 154px;
}

.mock-header #userName {
  display: block;
  max-width: 128px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mock-header .dropdown-trigger {
  display: inline-flex;
  min-height: 42px;
  max-width: min(320px, 32vw);
  align-items: center;
  gap: 8px;
  padding: 0 14px;
  border: 1px solid var(--marketing-line);
  border-radius: 14px;
  color: var(--marketing-ink);
  background: rgba(255, 253, 247, 0.88);
  font: inherit;
  font-weight: 400;
  cursor: pointer;
}

.mock-header .dropdown-trigger #userName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mock-header .dropdown-arrow {
  width: 0;
  height: 0;
  flex: 0 0 auto;
  border-top: 7px solid currentcolor;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  transition: transform 180ms ease;
}

.mock-header .dropdown-arrow.arrow-up {
  transform: rotate(180deg);
}

.mock-header .dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 30;
  display: none;
  min-width: 210px;
  padding: 8px;
  border: 1px solid var(--marketing-line);
  border-radius: 14px;
  background: #fffaf3;
  box-shadow: 0 18px 42px rgba(75, 51, 38, 0.13);
}

.mock-header .dropdown-menu.show {
  display: grid;
}

.mock-header .dropdown-item {
  padding: 10px 12px;
  border-radius: 10px;
  color: var(--marketing-ink-soft);
  text-decoration: none;
  white-space: nowrap;
}

.mock-header .dropdown-item:hover {
  color: var(--marketing-coral-dark);
  background: rgba(231, 90, 98, 0.08);
}

.mock-footer {
  --marketing-ink: #302a27;
  --marketing-ink-soft: #6c6159;
  --marketing-line: rgba(87, 65, 52, 0.16);
  box-sizing: border-box;
  border-top: 1px solid var(--marketing-line);
  color: var(--marketing-ink);
  background: rgba(255, 253, 248, 0.76);
  font-family: var(--marketing-body);
  padding: 0;
  text-align: left;
}

.mock-footer-inner {
  display: grid;
  grid-template-columns: minmax(210px, 0.75fr) minmax(460px, 1.65fr) auto;
  align-items: start;
  min-height: 190px;
  gap: 36px;
  padding: 36px 0;
}

.mock-footer-brand img {
  width: 148px;
  height: auto;
}

.mock-footer-brand p {
  max-width: 28ch;
  margin: 14px 0 0;
  color: var(--marketing-ink-soft);
  font-size: 0.9rem;
  line-height: 1.45;
}

.mock-footer-links {
  display: grid;
  grid-template-columns: repeat(3, minmax(120px, 1fr));
  gap: 28px;
  align-items: start;
  color: var(--marketing-ink-soft);
  font-size: 0.9rem;
  font-weight: 400;
}

.mock-footer-group h2 {
  margin: 0 0 13px;
  color: var(--marketing-ink);
  font-family: var(--marketing-body) !important;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  line-height: 1.3;
  text-transform: uppercase;
}

.mock-footer-group > div {
  display: grid;
  gap: 9px;
}

.mock-footer-group a {
  width: fit-content;
  font-weight: 600;
  line-height: 1.4;
}

.mock-social {
  justify-content: flex-end;
  gap: 12px;
}

.mock-social a {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  border: 1px solid var(--marketing-line);
  border-radius: 10px;
  color: var(--marketing-ink-soft);
}

.mock-social svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentcolor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.language-select {
  min-height: 40px;
  padding: 0 10px;
  border: 1px solid var(--marketing-line);
  border-radius: 10px;
  color: var(--marketing-ink);
  background: var(--marketing-paper, #fffaf3);
  font: inherit;
}

.mock-nav a:focus-visible,
.mock-footer a:focus-visible,
.mock-header button:focus-visible,
.mock-mobile-menu button:focus-visible,
.mock-footer select:focus-visible {
  outline: 3px solid rgba(231, 90, 98, 0.42);
  outline-offset: 3px;
}

@media (max-width: 1040px) {
  .mock-footer-inner {
    grid-template-columns: minmax(190px, 0.7fr) minmax(420px, 1.5fr);
  }

  .mock-social {
    grid-column: 1 / -1;
    justify-content: flex-end;
  }
}

@media (max-width: 920px) {
  .home-shell {
    width: min(100% - 30px, 680px);
  }

  .mock-nav {
    grid-template-columns: 1fr auto;
    min-height: 0;
    gap: 12px;
    margin-top: 22px;
    padding: 0 0 14px;
  }

  .mock-logo,
  .mock-logo img {
    width: clamp(154px, 31vw, 188px);
  }

  .mock-nav-links {
    grid-row: 2;
    grid-column: 1 / -1;
    justify-content: flex-start;
    overflow-x: auto;
    flex-wrap: nowrap;
    padding-bottom: 4px;
  }

  .mock-account-area {
    grid-column: 2;
    grid-row: 1;
    min-width: 0;
  }

  .mock-footer-inner {
    grid-template-columns: 1fr;
    gap: 32px;
    justify-items: start;
  }

  .mock-footer-links,
  .mock-social {
    justify-content: flex-start;
  }

  .mock-footer .mock-social {
    grid-column: auto;
  }
}

@media (max-width: 680px), (orientation: landscape) and (max-height: 520px) {
  .home-shell {
    width: min(100% - 28px, 1260px);
  }

  .mock-nav {
    grid-template-columns: 1fr auto;
    margin-top: 16px;
  }

  .mock-nav-links {
    display: none;
  }

  .mock-account-area {
    grid-column: 2;
    grid-row: 1;
    min-width: 0;
    justify-self: end;
  }

  .mock-header .mock-auth,
  .mock-header .user-dropdown {
    display: none !important;
    visibility: hidden;
    pointer-events: none;
  }

  .mock-header .mock-mobile-menu-toggle {
    position: relative;
    z-index: 1;
    visibility: visible;
    pointer-events: auto;
  }

  .mock-mobile-menu-toggle {
    display: inline-flex;
    width: 44px;
    height: 44px;
    align-items: center;
    justify-content: center;
    padding: 0 0 8px;
    border: 1px solid var(--marketing-line);
    border-radius: 14px;
    color: var(--marketing-ink);
    background: rgba(255, 253, 247, 0.72);
    font: inherit;
    font-size: 1.65rem;
    line-height: 1;
    cursor: pointer;
    transition: transform 150ms ease-out;
  }

  .mock-mobile-menu-toggle:active,
  .mock-mobile-menu-close:active {
    transform: scale(0.97);
  }

  .mock-mobile-menu {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow: hidden;
    padding: max(20px, env(safe-area-inset-top)) max(20px, env(safe-area-inset-right)) max(24px, env(safe-area-inset-bottom)) max(20px, env(safe-area-inset-left));
    color: var(--marketing-ink);
    background:
      linear-gradient(90deg, rgba(47, 42, 40, 0.035) 1px, transparent 1px) 0 0 / 44px 44px repeat,
      linear-gradient(180deg, rgba(47, 42, 40, 0.03) 1px, transparent 1px) 0 0 / 44px 44px repeat,
      radial-gradient(ellipse at 88% 0%, rgba(255, 255, 255, 0.82) 0 15%, transparent 42%),
      linear-gradient(180deg, #d8eeef 0%, #eef8f5 38%, #fff8f0 100%);
    opacity: 0;
    visibility: hidden;
    transform: translateY(-14px);
    pointer-events: none;
    transition:
      opacity 140ms cubic-bezier(0.215, 0.61, 0.355, 1),
      transform 140ms cubic-bezier(0.215, 0.61, 0.355, 1),
      visibility 0s linear 140ms;
  }

  .mock-mobile-menu[data-open="true"] {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
    pointer-events: auto;
    transition-delay: 0s;
  }

  .mock-mobile-menu-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 52px;
  }

  .mock-mobile-menu-logo {
    display: inline-flex;
    width: min(174px, 52vw);
    align-items: center;
  }

  .mock-mobile-menu-logo img {
    display: block;
    width: 100%;
    height: auto;
  }

  .mock-mobile-menu-close {
    display: inline-flex;
    width: 44px;
    height: 44px;
    align-items: center;
    justify-content: center;
    padding: 0 0 3px;
    border: 1px solid var(--marketing-line);
    border-radius: 14px;
    color: var(--marketing-ink);
    background: rgba(255, 253, 247, 0.58);
    font: inherit;
    font-size: 1.8rem;
    line-height: 1;
    cursor: pointer;
    transition: transform 150ms ease-out;
  }

  .mock-mobile-menu-nav {
    display: grid;
    align-content: start;
    width: min(100%, 540px);
    max-height: calc(100svh - 100px);
    margin: 0 auto;
    overflow-y: auto;
    padding: clamp(28px, 8vh, 64px) 0 24px;
  }

  .mock-mobile-menu-nav a {
    display: flex;
    min-height: 56px;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid rgba(87, 65, 52, 0.14);
    color: var(--marketing-ink);
    font-size: clamp(1.28rem, 5vw, 1.75rem);
    font-weight: 700;
    line-height: 1.2;
    text-decoration: none;
    transition: color 180ms cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  @media (hover: hover) and (pointer: fine) {
    .mock-mobile-menu-nav a:hover {
      color: var(--marketing-coral-dark);
    }
  }

  .mock-mobile-menu-divider {
    height: 1px;
    margin: 26px 0 8px;
    background: rgba(87, 65, 52, 0.18);
  }

  .mock-mobile-auth,
  .mock-mobile-user {
    display: grid;
    grid-template-columns: 1fr;
  }

  .mock-mobile-user {
    display: none;
  }

  .mock-mobile-auth a,
  .mock-mobile-user a {
    font-size: clamp(1.12rem, 4.2vw, 1.42rem);
    font-weight: 600;
  }

  .mock-footer-links {
    width: 100%;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 28px 20px;
  }

  .mock-footer-group:last-child {
    grid-column: 1 / -1;
  }
}

/* Short landscape phone viewports should never leave the full-page menu in
 * its hidden transition frame while Safari is settling the viewport. */
@media (orientation: landscape) and (max-height: 520px) {
  .mock-mobile-menu {
    transition: none;
  }
}

@media (max-width: 620px) {
  .mock-tagline {
    font-size: 0.58rem;
  }
}

html.mobile-menu-open {
  overflow: hidden;
}

@media (prefers-reduced-motion: reduce) {
  .mock-mobile-menu,
  .mock-mobile-menu-toggle,
  .mock-mobile-menu-close,
  .mock-mobile-menu-nav a {
    transition: none;
  }

  .mock-mobile-menu,
  .mock-mobile-menu-nav a {
    transform: none;
  }
}

/*
 * Homepage hero direction.
 *
 * The interactive card preview remains the visual anchor. The copy side
 * carries only the promise, one sentence, two actions, and one quiet proof
 * line so the first viewport has a single readable path.
 */
.homepage-mockup .mock-hero {
  padding-top: clamp(24px, 3.8vw, 54px);
}

.homepage-mockup .mock-hero-copy {
  align-self: center;
}

.homepage-mockup .mock-hero h1 {
  max-width: 12.8ch;
  font-size: clamp(2.95rem, 5.05vw, 5.05rem);
  line-height: 0.94;
  text-shadow: none;
}

.homepage-mockup .mock-hero-copy .lede {
  max-width: 38ch;
  margin-top: 22px;
  line-height: 1.58;
}

.homepage-mockup .mock-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  max-width: 100%;
  margin-top: 24px;
}

.homepage-mockup .mock-primary,
.homepage-mockup .mock-secondary {
  width: auto;
  flex: 0 0 auto;
}

.homepage-mockup .mock-hero .mini-feature-row,
.homepage-mockup .mock-hero .trust-row,
.homepage-mockup .mock-hero .proof-snapshot {
  display: none;
}

.homepage-mockup .mock-hero-proof {
  max-width: 38ch;
  margin: 17px 0 0;
  color: var(--ink-muted);
  font-size: 0.84rem;
  line-height: 1.45;
}

/* Keep the hero copy stable: the former animation began at opacity: 0. */
.homepage-mockup .motion-ready .mock-hero-copy {
  animation: homepage-hero-settle 700ms cubic-bezier(0.16, 1, 0.3, 1) both;
}

@keyframes homepage-hero-settle {
  from {
    transform: translateY(10px);
  }

  to {
    transform: translateY(0);
  }
}

@media (max-width: 820px) {
  .homepage-mockup .mock-hero .mock-secondary {
    display: inline-flex;
  }

  .homepage-mockup .mock-actions {
    max-width: 360px;
  }
}

@media (max-width: 560px) {
  .homepage-mockup .mock-actions {
    align-items: stretch;
    flex-direction: column;
    max-width: 360px;
  }

  .homepage-mockup .mock-primary,
  .homepage-mockup .mock-secondary {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .homepage-mockup .motion-ready .mock-hero-copy {
    animation: none;
  }
}

/*
 * Homepage how-it-works direction.
 *
 * Keep the illustration-led story, but make the steps feel like one editorial
 * sequence instead of four equal feature cards. The section heading is
 * intentionally direct: marketing pages do not need a decorative eyebrow.
 */
.homepage-mockup .how-panel {
  background: rgba(255, 253, 248, 0.58);
}

.homepage-mockup .how-panel .mock-section {
  padding-top: clamp(72px, 8vw, 112px);
  padding-bottom: clamp(84px, 9vw, 126px);
}

.homepage-mockup .how-panel .how-grid {
  grid-template-columns: minmax(200px, 0.34fr) minmax(0, 1fr);
  gap: clamp(42px, 6vw, 90px);
  align-items: end;
}

.homepage-mockup .how-panel .how-grid > picture {
  display: block;
  align-self: end;
}

.homepage-mockup .how-panel .postwoman {
  width: min(280px, 100%);
  margin: 0;
}

.homepage-mockup .how-panel .templates-head {
  max-width: 58rem;
  margin: 0;
  text-align: left;
}

.homepage-mockup .how-panel .templates-head h2 {
  max-width: 13ch;
  margin-top: 0;
  font-size: clamp(2.55rem, 4.1vw, 4.55rem);
  line-height: 0.98;
  text-wrap: balance;
}

.homepage-mockup .how-panel .templates-head p {
  max-width: 48ch;
  margin: 16px 0 0;
}

.homepage-mockup .how-panel .step-track {
  position: relative;
  --how-step-art-width: 170px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: clamp(18px, 2.8vw, 36px);
  margin-top: clamp(40px, 4.8vw, 60px);
}

.homepage-mockup .how-panel .step-track::before {
  position: absolute;
  top: 0.68rem;
  right: 0;
  left: 0;
  height: 1px;
  background: linear-gradient(90deg, rgba(201, 71, 80, 0.16), rgba(201, 71, 80, 0.36) 50%, rgba(201, 71, 80, 0.16));
  content: "";
}

.homepage-mockup .how-panel .step-card {
  min-height: 0;
  padding: 0;
  gap: 16px;
}

.homepage-mockup .how-panel .step-number {
  position: relative;
  z-index: 1;
  display: inline-flex;
  width: auto;
  height: auto;
  min-width: 0;
  align-items: center;
  justify-content: center;
  justify-self: center;
  margin-left: 0;
  padding: 0 0.48rem;
  border-radius: 0;
  background: rgba(255, 253, 248, 0.94);
  box-shadow: 0 0 0 5px rgba(255, 253, 248, 0.72);
  color: var(--coral-dark);
  font-family: var(--display);
  font-size: 1.35rem;
  font-weight: 400;
  line-height: 1;
}

.homepage-mockup .how-panel .step-art {
  display: flex;
  width: min(100%, var(--how-step-art-width));
  height: auto;
  aspect-ratio: 3 / 2;
  min-height: 0;
  max-height: none;
  align-items: flex-end;
  justify-content: center;
  justify-self: center;
  overflow: visible;
  position: static;
  background: transparent;
}

.homepage-mockup .how-panel .step-art picture {
  display: block;
  width: 100%;
  height: 100%;
}

.homepage-mockup .how-panel .step-art img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center bottom;
}

.homepage-mockup .how-panel .step-card > div:last-child {
  width: min(100%, var(--how-step-art-width));
  max-width: var(--how-step-art-width);
  justify-self: center;
}

.homepage-mockup .how-panel .step-card h3 {
  margin: 0;
  color: var(--ink);
  font-size: 1.08rem;
  font-weight: 800;
  line-height: 1.28;
  text-align: left;
}

.homepage-mockup .how-panel .step-card p {
  max-width: 22ch;
  margin: 8px 0 0;
  color: var(--ink-soft);
  font-size: 0.95rem;
  line-height: 1.55;
  text-align: left;
}

/* The process remains visible while it enters the viewport. This avoids a
 * blank section during a fast scroll or when the observer initializes late. */
.homepage-mockup .how-panel .motion-reveal,
.homepage-mockup .how-panel .motion-reveal.is-visible {
  opacity: 1;
  transform: none;
  transition: none;
  transition-delay: 0ms;
  will-change: auto;
}

.homepage-mockup .motion-ready .how-panel .step-card.is-visible .step-number {
  animation: none;
}

@media (max-width: 1120px) {
  .homepage-mockup .how-panel .how-grid {
    grid-template-columns: 1fr;
    gap: 28px;
  }

  .homepage-mockup .how-panel .how-grid > picture {
    justify-self: start;
  }

  .homepage-mockup .how-panel .postwoman {
    display: block;
    width: min(210px, 42vw);
  }
}

@media (max-width: 820px) {
  .homepage-mockup .how-panel .step-track {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .homepage-mockup .how-panel .step-track::before {
    display: none;
  }

  .homepage-mockup .how-panel .step-number {
    margin-left: 0;
    padding: 0;
    background: transparent;
    box-shadow: none;
  }
}

@media (max-width: 680px) {
  .homepage-mockup .how-panel .mock-section {
    padding-top: 64px;
    padding-bottom: 78px;
  }

  .homepage-mockup .how-panel .postwoman {
    width: min(190px, 48vw);
    margin-inline: auto;
  }

  .homepage-mockup .how-panel .how-grid > picture {
    justify-self: center;
  }

  .homepage-mockup .how-panel .templates-head {
    text-align: center;
  }

  .homepage-mockup .how-panel .templates-head h2 {
    max-width: 12ch;
    margin-inline: auto;
    font-size: clamp(2.35rem, 11vw, 3.5rem);
  }

  .homepage-mockup .how-panel .templates-head p {
    margin-inline: auto;
    text-align: center;
  }

  .homepage-mockup .how-panel .step-track {
    --how-step-art-width: 360px;
    grid-template-columns: 1fr;
    gap: 46px;
    margin-top: 38px;
  }

  .homepage-mockup .how-panel .step-card {
    grid-template-columns: minmax(0, 1fr);
    row-gap: 12px;
  }

  .homepage-mockup .how-panel .step-card:not(:last-child)::before {
    display: none;
  }

  .homepage-mockup .how-panel .step-number {
    grid-column: 1;
    grid-row: 1;
    align-self: start;
    margin: 0;
    padding: 0;
    background: transparent;
    box-shadow: none;
  }

  .homepage-mockup .how-panel .step-art {
    grid-column: 1;
    grid-row: 2;
    width: min(100%, var(--how-step-art-width));
    height: auto;
    aspect-ratio: 3 / 2;
  }

  .homepage-mockup .how-panel .step-card > div:last-child {
    grid-column: 1;
    grid-row: 3;
    text-align: center;
    justify-self: center;
  }

  .homepage-mockup .how-panel .step-card h3,
  .homepage-mockup .how-panel .step-card p {
    text-align: center;
  }

  .homepage-mockup .how-panel .step-card p {
    margin-inline: auto;
  }
}

@media (max-width: 420px) {
  .homepage-mockup .how-panel .step-track {
    --how-step-art-width: 330px;
  }
}

/*
 * Homepage closing CTA direction.
 *
 * The last section is a calm handoff: one direct invitation, one primary
 * action, one quiet pricing link, and a single piece of card artwork. The
 * dark ink surface gives the closing moment a clear, quiet finish.
 */
.homepage-mockup .mock-final {
  grid-template-columns: minmax(300px, 0.96fr) minmax(280px, 1.04fr);
  gap: clamp(32px, 6vw, 78px);
  padding: clamp(44px, 6vw, 72px);
  border-color: rgba(201, 71, 80, 0.22);
  background: #e8a198;
  color: var(--ink);
  box-shadow: 0 14px 0 rgba(201, 71, 80, 0.12), 0 24px 46px rgba(84, 55, 44, 0.12);
  overflow: hidden;
}

.homepage-mockup .mock-final > div:first-child {
  max-width: 540px;
}

.homepage-mockup .mock-final .mock-eyebrow {
  display: none;
}

.homepage-mockup .mock-final h2 {
  max-width: 13ch;
  margin-top: 0;
  color: #fffaf9;
  font-size: clamp(2.55rem, 4.6vw, 4.7rem);
  line-height: 0.96;
  text-wrap: balance;
}

.homepage-mockup .mock-final > div:first-child > p:not(.mock-eyebrow) {
  max-width: 39ch;
  margin-top: 20px;
  color: rgba(48, 42, 39, 0.76);
  line-height: 1.58;
}

.homepage-mockup .mock-final .mock-actions {
  margin-top: 28px;
}

.homepage-mockup .mock-final .mock-secondary {
  display: inline-flex;
  min-height: auto;
  border: 0;
  border-bottom: 1px solid rgba(48, 42, 39, 0.42);
  border-radius: 0;
  background: transparent;
  color: var(--ink);
  padding: 5px 0 3px;
  font-weight: 700;
}

.homepage-mockup .mock-final .mock-secondary:hover {
  border-bottom-color: var(--ink);
  background: transparent;
  box-shadow: none;
}

.homepage-mockup .mock-final .mock-primary {
  border-color: var(--cream);
  background: var(--cream);
  color: var(--ink);
}

.homepage-mockup .mock-final .mock-primary:hover {
  border-color: var(--cream);
  background: var(--cream);
  color: var(--ink);
}

/* Keep the closing invitation present; it should never blink in on scroll. */
.homepage-mockup .mock-final .motion-reveal,
.homepage-mockup .mock-final .motion-reveal.is-visible {
  opacity: 1;
  transform: none;
  transition: none;
  transition-delay: 0ms;
  will-change: auto;
}

.homepage-mockup .mock-final-art {
  min-height: 250px;
  display: grid;
  place-items: center end;
}

.homepage-mockup .mock-final-art picture {
  display: block;
  width: min(100%, 560px);
}

.homepage-mockup .mock-final-art img {
  display: block;
  width: 100%;
  height: auto;
  mix-blend-mode: normal;
  opacity: 1;
  transform: none;
  filter: none;
}

@media (max-width: 1120px) {
  .homepage-mockup .mock-final {
    grid-template-columns: 1fr;
  }

  .homepage-mockup .mock-final-art {
    min-height: 190px;
    place-items: center;
  }

  .homepage-mockup .mock-final-art img {
    width: 100%;
  }

  .homepage-mockup .mock-final-art picture {
    width: min(100%, 430px);
  }
}

@media (max-width: 560px) {
  .homepage-mockup .mock-final {
    padding: 40px 28px 34px;
  }

  .homepage-mockup .mock-final h2 {
    max-width: 12ch;
    font-size: clamp(2.4rem, 11vw, 3.6rem);
  }

  .homepage-mockup .mock-final .mock-secondary {
    width: fit-content;
    align-self: flex-start;
  }

  .homepage-mockup .mock-final-art {
    min-height: 160px;
    margin-top: 8px;
  }

  .homepage-mockup .mock-final-art img {
    width: 100%;
  }

  .homepage-mockup .mock-final-art picture {
    width: min(100%, 320px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .homepage-mockup .mock-final .motion-reveal,
  .homepage-mockup .mock-final .motion-reveal.is-visible {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./front/src/styles/marketing_chrome.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;EACE,gCAAgC;EAChC,0DAA0D;EAC1D,sBAAsB;AACxB;;AAEA;;;;EAIE;AACF;EACE,yCAAyC;EACzC,kEAAkE;EAClE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,kEAAkE;EAClE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,oEAAoE;EACpE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,uHAAuH;EACvH,kFAAkF;EAClF,qGAAqG;EACrG,6BAA6B;EAC7B,mCAAmC;EACnC,6BAA6B;EAC7B,iCAAiC;EACjC,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,0BAA0B;EAC1B,wCAAwC;EACxC,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;;;EAGE;AACF;;EAEE,aAAa;EACb,aAAa;EACb,oBAAoB;AACtB;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;;;;EAIE;AACF;;;EAGE;;gIAE8H;AAChI;;AAEA,0EAA0E;AAC1E;EACE;;gIAE8H;AAChI;;AAEA;0EAC0E;AAC1E;EACE;;;kEAGgE;AAClE;;AAEA;EACE;;;IAGE,0KAA0K;EAC5K;;EAEA;IACE,0KAA0K;EAC5K;AACF;;AAEA;;gEAEgE;AAChE;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE;;iIAE6H;EAC/H;AACF;;AAEA;;;;EAIE;AACF;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,gFAAgF;AAChF;EACE;;;;;;;yBAOuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;EAIE;AACF;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,wGAAwG;AAC1G;;AAEA;;;EAGE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,kFAAkF;AAClF;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,uCAAuC;EACvC,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;EACrC,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,cAAc;EACd,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,wCAAwC;EACxC,sBAAsB;EACtB,2CAA2C;EAC3C,2BAA2B;EAC3B,qCAAqC;EACrC,kCAAkC;EAClC,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uEAAuE;EACvE,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;EAC3C,aAAa;AACf;;AAEA;;;;;EAKE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE;IACE,gEAAgE;EAClE;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;IAC/B,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,oBAAoB;EACtB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,uCAAuC;IACvC,mBAAmB;IACnB,2BAA2B;IAC3B,qCAAqC;IACrC,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,oCAAoC;EACtC;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,8JAA8J;IAC9J,2BAA2B;IAC3B;;;;oEAIgE;IAChE,UAAU;IACV,kBAAkB;IAClB,4BAA4B;IAC5B,oBAAoB;IACpB;;;gCAG4B;EAC9B;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,uCAAuC;IACvC,mBAAmB;IACnB,2BAA2B;IAC3B,qCAAqC;IACrC,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,oCAAoC;EACtC;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,uBAAuB;IACvB,gCAAgC;IAChC,cAAc;IACd,gBAAgB;IAChB,sCAAsC;EACxC;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,+CAA+C;IAC/C,2BAA2B;IAC3B,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,2DAA2D;EAC7D;;EAEA;IACE;MACE,kCAAkC;IACpC;EACF;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;;IAEE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gDAAgD;IAChD,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;uEACuE;AACvE;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;;;IAIE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;;;;;;EAME;AACF;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,cAAc;AAChB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,yEAAyE;AACzE;EACE,wEAAwE;AAC1E;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;;;;;EAME;AACF;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,2DAA2D;EAC3D,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gDAAgD;EAChD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,OAAO;EACP,WAAW;EACX,iHAAiH;EACjH,WAAW;AACb;;AAEA;EACE,aAAa;EACb,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,+CAA+C;EAC/C,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;8EAC8E;AAC9E;;EAEE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,UAAU;IACV,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,uCAAuC;EACzC;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,2CAA2C;IAC3C,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;;;;;;EAME;AACF;EACE,kEAAkE;EAClE,2BAA2B;EAC3B,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,gFAAgF;EAChF,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,wCAAwC;EACxC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,+CAA+C;EAC/C,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA,6EAA6E;AAC7E;;EAEE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/*\n * Canonical marketing chrome.\n *\n * This file is consumed by the Vue app and copied to front/dist by\n * scripts/sync_marketing_chrome.mjs for every generated marketing page.\n * Page-family styles may add content styles, but must not redefine the\n * header, footer, account menu, or shared navigation layout here.\n */\n\n@font-face {\n  font-family: \"Sharewell Glacial\";\n  src: url(\"/fonts/GlacialIndifference.woff\") format(\"woff\");\n  font-display: optional;\n}\n\n/*\n * Optional avoids moving the first viewport when a webfont arrives after the\n * initial paint. These local-only faces keep fallback metrics close when the\n * font is available immediately.\n */\n@font-face {\n  font-family: \"Sharewell Glacial Fallback\";\n  src: local(\"Avenir Next\"), local(\"Helvetica Neue\"), local(\"Arial\");\n  font-style: normal;\n  font-weight: 400;\n  font-display: optional;\n  size-adjust: 95.4%;\n  ascent-override: 93.75%;\n  descent-override: 25%;\n  line-gap-override: 0%;\n}\n\n@font-face {\n  font-family: \"Sharewell Glacial Fallback\";\n  src: local(\"Avenir Next\"), local(\"Helvetica Neue\"), local(\"Arial\");\n  font-style: normal;\n  font-weight: 700 900;\n  font-display: optional;\n  size-adjust: 89.4%;\n  ascent-override: 93.75%;\n  descent-override: 25%;\n  line-gap-override: 0%;\n}\n\n@font-face {\n  font-family: \"Sharewell Display Fallback\";\n  src: local(\"Georgia\");\n  font-style: normal;\n  font-weight: 400;\n  font-display: optional;\n  size-adjust: 100%;\n  ascent-override: 103%;\n  descent-override: 33%;\n  line-gap-override: 0%;\n}\n\n@font-face {\n  font-family: \"Sharewell Hand Fallback\";\n  src: local(\"Bradley Hand\"), local(\"Comic Sans MS\"), local(\"cursive\");\n  font-style: normal;\n  font-weight: 400;\n  font-display: optional;\n  size-adjust: 84%;\n  ascent-override: 106%;\n  descent-override: 31%;\n  line-gap-override: 0%;\n}\n\n:root {\n  --marketing-body: \"Sharewell Glacial\", \"Sharewell Glacial Fallback\", \"Avenir Next\", \"Helvetica Neue\", Arial, sans-serif;\n  --marketing-display: \"DM Serif Text\", \"Sharewell Display Fallback\", Georgia, serif;\n  --marketing-hand: \"Patrick Hand\", \"Sharewell Hand Fallback\", \"Bradley Hand\", \"Comic Sans MS\", cursive;\n  --body: var(--marketing-body);\n  --display: var(--marketing-display);\n  --hand: var(--marketing-hand);\n  --faq-body: var(--marketing-body);\n  --faq-display: var(--marketing-display);\n  --sans: var(--marketing-body);\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nimg {\n  display: block;\n  max-width: 100%;\n}\n\n.skip-link {\n  position: fixed;\n  top: 0.75rem;\n  left: 0.75rem;\n  z-index: 30;\n  padding: 0.7rem 1rem;\n  border-radius: 999px;\n  color: #fff;\n  background: #29262f;\n  transform: translateY(-160%);\n  transition: transform 180ms ease;\n}\n\n.skip-link:focus {\n  transform: translateY(0);\n}\n\n.home-shell {\n  width: min(1260px, calc(100% - 48px));\n  margin-inline: auto;\n}\n\n.mock-header {\n  --marketing-ink: #302a27;\n  --marketing-ink-soft: #6c6159;\n  --marketing-paper: #fffaf3;\n  --marketing-line: rgba(87, 65, 52, 0.16);\n  --marketing-coral: #e75a62;\n  --marketing-coral-dark: #d64b55;\n  position: relative;\n  z-index: 10;\n  display: flow-root;\n  overflow: visible;\n  color: var(--marketing-ink);\n  font-family: var(--marketing-body);\n}\n\n/*\n * The header is navigation chrome only. Hero and page sections own their\n * visual surfaces, so no shared pseudo-layer can wash over a page title.\n */\n.mock-header::before,\n.mock-header::after {\n  display: none;\n  content: none;\n  pointer-events: none;\n}\n\n/* Guide heroes also own the first-viewport artwork; keep chrome over it. */\n.guide-page > .mock-header {\n  position: absolute;\n  inset: 0 0 auto;\n  z-index: 10;\n  background: transparent;\n}\n\n/*\n * Keep image-led heroes vivid on the illustration side, but give the copy a\n * deliberate cream reading zone. The header remains transparent over the same\n * image, so the surface still reads as one continuous scene.\n */\n.guide-page .hero-art::before,\n.landing-page .hero-art::before,\n.occasion-page .hero::before {\n  background:\n    linear-gradient(90deg, rgba(255, 253, 248, 0.84) 0%, rgba(255, 253, 248, 0.74) 20%, rgba(255, 253, 248, 0.50) 38%, rgba(255, 253, 248, 0.22) 58%, rgba(255, 253, 248, 0.05) 76%, rgba(255, 253, 248, 0) 92%),\n    linear-gradient(180deg, rgba(232, 247, 248, 0.16) 0%, rgba(255, 253, 248, 0) 45%, rgba(255, 253, 248, 0.18) 100%) !important;\n}\n\n/* The directory keeps the lighter treatment used by the reference hero. */\n.occasion-directory-page .hero::before {\n  background:\n    linear-gradient(90deg, rgba(255, 253, 248, 0.64) 0%, rgba(255, 253, 248, 0.58) 20%, rgba(255, 253, 248, 0.42) 38%, rgba(255, 253, 248, 0.20) 58%, rgba(255, 253, 248, 0.06) 74%, rgba(255, 253, 248, 0) 90%),\n    linear-gradient(180deg, rgba(232, 247, 248, 0.14) 0%, rgba(255, 253, 248, 0) 45%, rgba(255, 253, 248, 0.16) 100%) !important;\n}\n\n/* Example pages use a pastel stage instead of a full-bleed hero image. Keep\n * that stage airy, but let the blue-to-peach color carry more presence. */\n.evidence-page .hero {\n  background:\n    radial-gradient(circle at 82% 12%, rgba(255, 255, 255, 0.66) 0 8%, transparent 22%),\n    radial-gradient(circle at 12% 36%, rgba(255, 255, 255, 0.44) 0 8%, transparent 24%),\n    linear-gradient(145deg, #d1e9e9 0%, #e5f1ed 54%, #f4ccb6 100%);\n}\n\n@media (max-width: 760px) {\n  .guide-page .hero-art::before,\n  .landing-page .hero-art::before,\n  .occasion-page .hero::before {\n    background: linear-gradient(180deg, rgba(255, 253, 248, 0.58) 0%, rgba(255, 253, 248, 0.48) 29%, rgba(255, 253, 248, 0.28) 58%, rgba(255, 253, 248, 0.38) 100%) !important;\n  }\n\n  .occasion-directory-page .hero::before {\n    background: linear-gradient(180deg, rgba(255, 253, 248, 0.50) 0%, rgba(255, 253, 248, 0.42) 29%, rgba(255, 253, 248, 0.24) 58%, rgba(255, 253, 248, 0.34) 100%) !important;\n  }\n}\n\n/* The promotion guide keeps a soft full-bleed reading wash in landscape.\n * It avoids a separate panel over the illustration while preserving enough\n * contrast for the longer French heading on a short viewport. */\n@media (max-width: 930px) and (orientation: landscape) {\n  .promotion-guide-page > .mock-header .mock-nav {\n    margin-top: 10px;\n    padding-bottom: 4px;\n  }\n\n  .promotion-guide-page > .mock-header .mock-logo,\n  .promotion-guide-page > .mock-header .mock-logo img {\n    width: clamp(142px, 23vw, 164px);\n  }\n\n  .promotion-guide-page > .mock-header .mock-mobile-menu-toggle {\n    width: 38px;\n    height: 38px;\n    border-radius: 12px;\n    font-size: 1.4rem;\n  }\n\n  .promotion-guide-page .hero-art::before {\n    background:\n      linear-gradient(90deg, rgba(255, 253, 248, 0.98) 0%, rgba(255, 253, 248, 0.93) 38%, rgba(255, 253, 248, 0.74) 57%, rgba(255, 253, 248, 0.28) 78%, rgba(255, 253, 248, 0) 100%),\n      linear-gradient(180deg, rgba(232, 247, 248, 0.2) 0%, rgba(255, 253, 248, 0) 56%, rgba(255, 253, 248, 0.42) 100%) !important;\n  }\n}\n\n/*\n * The homepage already owns the continuous paper surface behind its hero.\n * Remove the legacy header fade so it cannot wash over the H1 or draw a seam\n * between the navigation and the first hero row.\n */\n.homepage-mockup .mock-header::after {\n  display: none;\n}\n\n.homepage-mockup .mock-header::before {\n  display: none;\n}\n\n/* Carry the hero's warm sky-to-paper wash from the header into the first row. */\n.homepage-mockup {\n  background:\n    linear-gradient(90deg, rgba(47, 42, 40, 0.035) 1px, transparent 1px) 0 0 / 44px 44px repeat,\n    linear-gradient(180deg, rgba(47, 42, 40, 0.03) 1px, transparent 1px) 0 0 / 44px 44px repeat,\n    radial-gradient(ellipse at 72% 18%, rgba(255, 255, 255, 0.72) 0 12%, transparent 31%) 0 0 / 100% 360px no-repeat,\n    radial-gradient(ellipse at 88% 34%, rgba(255, 255, 255, 0.58) 0 10%, transparent 28%) 0 0 / 100% 360px no-repeat,\n    radial-gradient(ellipse at 13% 28%, rgba(255, 255, 255, 0.5) 0 9%, transparent 26%) 0 0 / 100% 360px no-repeat,\n    linear-gradient(180deg, #d8eeef 0%, #eef8f5 46%, var(--paper, #fff8f0) 100%) 0 0 / 100% 360px no-repeat,\n    var(--paper, #fff8f0);\n}\n\n.homepage-mockup .mock-header {\n  background: transparent;\n}\n\n/*\n * The occasions directory owns the artwork for its first viewport. The\n * shared sky layer must stay out of that artwork, otherwise it washes over\n * the first heading and creates a visible header-to-hero seam.\n */\n.occasion-directory-page .mock-header::before {\n  display: none;\n}\n\n.occasion-directory-page .mock-header {\n  background: transparent;\n}\n\n\n.mock-nav {\n  position: relative;\n  z-index: 3;\n  display: grid;\n  grid-template-columns: 220px minmax(0, 1fr) auto;\n  align-items: center;\n  min-height: 64px;\n  gap: 24px;\n  margin-top: 24px;\n  padding: 0;\n}\n\n.mock-account-area {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  min-width: 154px;\n}\n\n.mock-mobile-menu-toggle,\n.mock-mobile-menu {\n  display: none;\n}\n\n.mock-brand {\n  display: grid;\n  width: fit-content;\n  justify-items: center;\n  gap: 4px;\n}\n\n.mock-logo {\n  display: inline-flex;\n  width: 198px;\n  align-items: center;\n}\n\n.mock-logo img {\n  width: 198px;\n  height: auto;\n}\n\n.mock-tagline {\n  margin: 0;\n  color: var(--marketing-coral-dark);\n  font-size: 0.66rem;\n  font-weight: 800;\n  line-height: 1.15;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.mock-nav-links,\n.mock-auth,\n.mock-social {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.mock-nav-links {\n  justify-content: center;\n  gap: clamp(18px, 3vw, 36px);\n  color: var(--marketing-ink-soft);\n  font-size: 0.9rem;\n  font-weight: 700;\n}\n\n.mock-auth {\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.mock-nav a,\n.mock-footer a {\n  color: inherit;\n  text-decoration: none;\n  transition: color 220ms ease, background-color 220ms ease, border-color 220ms ease, transform 220ms ease;\n}\n\n.mock-nav-links a:hover,\n.mock-auth a:hover,\n.mock-footer a:hover {\n  color: var(--marketing-ink);\n  transform: translateY(-1px);\n}\n\n.mock-auth a {\n  display: inline-flex;\n  min-height: 42px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 16px;\n  border-radius: 14px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.mock-auth .mock-signup {\n  border: 1px solid var(--marketing-coral);\n  color: #fffdf7;\n  background: var(--marketing-coral);\n}\n\n.mock-auth .mock-signup:hover {\n  border-color: var(--marketing-coral-dark);\n  color: #fffdf7;\n  background: var(--marketing-coral-dark);\n}\n\n.mock-header .user-dropdown {\n  position: relative;\n  z-index: 20;\n}\n\n/* Reserve the signed-out/signed-in width so auth hydration cannot move the nav. */\n.mock-header .mock-auth,\n.mock-header .user-dropdown {\n  min-width: 154px;\n}\n\n.mock-header #userName {\n  display: block;\n  max-width: 128px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mock-header .dropdown-trigger {\n  display: inline-flex;\n  min-height: 42px;\n  max-width: min(320px, 32vw);\n  align-items: center;\n  gap: 8px;\n  padding: 0 14px;\n  border: 1px solid var(--marketing-line);\n  border-radius: 14px;\n  color: var(--marketing-ink);\n  background: rgba(255, 253, 247, 0.88);\n  font: inherit;\n  font-weight: 400;\n  cursor: pointer;\n}\n\n.mock-header .dropdown-trigger #userName {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mock-header .dropdown-arrow {\n  width: 0;\n  height: 0;\n  flex: 0 0 auto;\n  border-top: 7px solid currentcolor;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n  transition: transform 180ms ease;\n}\n\n.mock-header .dropdown-arrow.arrow-up {\n  transform: rotate(180deg);\n}\n\n.mock-header .dropdown-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 30;\n  display: none;\n  min-width: 210px;\n  padding: 8px;\n  border: 1px solid var(--marketing-line);\n  border-radius: 14px;\n  background: #fffaf3;\n  box-shadow: 0 18px 42px rgba(75, 51, 38, 0.13);\n}\n\n.mock-header .dropdown-menu.show {\n  display: grid;\n}\n\n.mock-header .dropdown-item {\n  padding: 10px 12px;\n  border-radius: 10px;\n  color: var(--marketing-ink-soft);\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.mock-header .dropdown-item:hover {\n  color: var(--marketing-coral-dark);\n  background: rgba(231, 90, 98, 0.08);\n}\n\n.mock-footer {\n  --marketing-ink: #302a27;\n  --marketing-ink-soft: #6c6159;\n  --marketing-line: rgba(87, 65, 52, 0.16);\n  box-sizing: border-box;\n  border-top: 1px solid var(--marketing-line);\n  color: var(--marketing-ink);\n  background: rgba(255, 253, 248, 0.76);\n  font-family: var(--marketing-body);\n  padding: 0;\n  text-align: left;\n}\n\n.mock-footer-inner {\n  display: grid;\n  grid-template-columns: minmax(210px, 0.75fr) minmax(460px, 1.65fr) auto;\n  align-items: start;\n  min-height: 190px;\n  gap: 36px;\n  padding: 36px 0;\n}\n\n.mock-footer-brand img {\n  width: 148px;\n  height: auto;\n}\n\n.mock-footer-brand p {\n  max-width: 28ch;\n  margin: 14px 0 0;\n  color: var(--marketing-ink-soft);\n  font-size: 0.9rem;\n  line-height: 1.45;\n}\n\n.mock-footer-links {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(120px, 1fr));\n  gap: 28px;\n  align-items: start;\n  color: var(--marketing-ink-soft);\n  font-size: 0.9rem;\n  font-weight: 400;\n}\n\n.mock-footer-group h2 {\n  margin: 0 0 13px;\n  color: var(--marketing-ink);\n  font-family: var(--marketing-body) !important;\n  font-size: 0.75rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  line-height: 1.3;\n  text-transform: uppercase;\n}\n\n.mock-footer-group > div {\n  display: grid;\n  gap: 9px;\n}\n\n.mock-footer-group a {\n  width: fit-content;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.mock-social {\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.mock-social a {\n  display: grid;\n  width: 38px;\n  height: 38px;\n  place-items: center;\n  border: 1px solid var(--marketing-line);\n  border-radius: 10px;\n  color: var(--marketing-ink-soft);\n}\n\n.mock-social svg {\n  width: 20px;\n  height: 20px;\n  fill: none;\n  stroke: currentcolor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.language-select {\n  min-height: 40px;\n  padding: 0 10px;\n  border: 1px solid var(--marketing-line);\n  border-radius: 10px;\n  color: var(--marketing-ink);\n  background: var(--marketing-paper, #fffaf3);\n  font: inherit;\n}\n\n.mock-nav a:focus-visible,\n.mock-footer a:focus-visible,\n.mock-header button:focus-visible,\n.mock-mobile-menu button:focus-visible,\n.mock-footer select:focus-visible {\n  outline: 3px solid rgba(231, 90, 98, 0.42);\n  outline-offset: 3px;\n}\n\n@media (max-width: 1040px) {\n  .mock-footer-inner {\n    grid-template-columns: minmax(190px, 0.7fr) minmax(420px, 1.5fr);\n  }\n\n  .mock-social {\n    grid-column: 1 / -1;\n    justify-content: flex-end;\n  }\n}\n\n@media (max-width: 920px) {\n  .home-shell {\n    width: min(100% - 30px, 680px);\n  }\n\n  .mock-nav {\n    grid-template-columns: 1fr auto;\n    min-height: 0;\n    gap: 12px;\n    margin-top: 22px;\n    padding: 0 0 14px;\n  }\n\n  .mock-logo,\n  .mock-logo img {\n    width: clamp(154px, 31vw, 188px);\n  }\n\n  .mock-nav-links {\n    grid-row: 2;\n    grid-column: 1 / -1;\n    justify-content: flex-start;\n    overflow-x: auto;\n    flex-wrap: nowrap;\n    padding-bottom: 4px;\n  }\n\n  .mock-account-area {\n    grid-column: 2;\n    grid-row: 1;\n    min-width: 0;\n  }\n\n  .mock-footer-inner {\n    grid-template-columns: 1fr;\n    gap: 32px;\n    justify-items: start;\n  }\n\n  .mock-footer-links,\n  .mock-social {\n    justify-content: flex-start;\n  }\n\n  .mock-footer .mock-social {\n    grid-column: auto;\n  }\n}\n\n@media (max-width: 680px), (orientation: landscape) and (max-height: 520px) {\n  .home-shell {\n    width: min(100% - 28px, 1260px);\n  }\n\n  .mock-nav {\n    grid-template-columns: 1fr auto;\n    margin-top: 16px;\n  }\n\n  .mock-nav-links {\n    display: none;\n  }\n\n  .mock-account-area {\n    grid-column: 2;\n    grid-row: 1;\n    min-width: 0;\n    justify-self: end;\n  }\n\n  .mock-header .mock-auth,\n  .mock-header .user-dropdown {\n    display: none !important;\n    visibility: hidden;\n    pointer-events: none;\n  }\n\n  .mock-header .mock-mobile-menu-toggle {\n    position: relative;\n    z-index: 1;\n    visibility: visible;\n    pointer-events: auto;\n  }\n\n  .mock-mobile-menu-toggle {\n    display: inline-flex;\n    width: 44px;\n    height: 44px;\n    align-items: center;\n    justify-content: center;\n    padding: 0 0 8px;\n    border: 1px solid var(--marketing-line);\n    border-radius: 14px;\n    color: var(--marketing-ink);\n    background: rgba(255, 253, 247, 0.72);\n    font: inherit;\n    font-size: 1.65rem;\n    line-height: 1;\n    cursor: pointer;\n    transition: transform 150ms ease-out;\n  }\n\n  .mock-mobile-menu-toggle:active,\n  .mock-mobile-menu-close:active {\n    transform: scale(0.97);\n  }\n\n  .mock-mobile-menu {\n    position: fixed;\n    inset: 0;\n    z-index: 1000;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    overflow: hidden;\n    padding: max(20px, env(safe-area-inset-top)) max(20px, env(safe-area-inset-right)) max(24px, env(safe-area-inset-bottom)) max(20px, env(safe-area-inset-left));\n    color: var(--marketing-ink);\n    background:\n      linear-gradient(90deg, rgba(47, 42, 40, 0.035) 1px, transparent 1px) 0 0 / 44px 44px repeat,\n      linear-gradient(180deg, rgba(47, 42, 40, 0.03) 1px, transparent 1px) 0 0 / 44px 44px repeat,\n      radial-gradient(ellipse at 88% 0%, rgba(255, 255, 255, 0.82) 0 15%, transparent 42%),\n      linear-gradient(180deg, #d8eeef 0%, #eef8f5 38%, #fff8f0 100%);\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(-14px);\n    pointer-events: none;\n    transition:\n      opacity 140ms cubic-bezier(0.215, 0.61, 0.355, 1),\n      transform 140ms cubic-bezier(0.215, 0.61, 0.355, 1),\n      visibility 0s linear 140ms;\n  }\n\n  .mock-mobile-menu[data-open=\"true\"] {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n    pointer-events: auto;\n    transition-delay: 0s;\n  }\n\n  .mock-mobile-menu-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-height: 52px;\n  }\n\n  .mock-mobile-menu-logo {\n    display: inline-flex;\n    width: min(174px, 52vw);\n    align-items: center;\n  }\n\n  .mock-mobile-menu-logo img {\n    display: block;\n    width: 100%;\n    height: auto;\n  }\n\n  .mock-mobile-menu-close {\n    display: inline-flex;\n    width: 44px;\n    height: 44px;\n    align-items: center;\n    justify-content: center;\n    padding: 0 0 3px;\n    border: 1px solid var(--marketing-line);\n    border-radius: 14px;\n    color: var(--marketing-ink);\n    background: rgba(255, 253, 247, 0.58);\n    font: inherit;\n    font-size: 1.8rem;\n    line-height: 1;\n    cursor: pointer;\n    transition: transform 150ms ease-out;\n  }\n\n  .mock-mobile-menu-nav {\n    display: grid;\n    align-content: start;\n    width: min(100%, 540px);\n    max-height: calc(100svh - 100px);\n    margin: 0 auto;\n    overflow-y: auto;\n    padding: clamp(28px, 8vh, 64px) 0 24px;\n  }\n\n  .mock-mobile-menu-nav a {\n    display: flex;\n    min-height: 56px;\n    align-items: center;\n    padding: 12px 0;\n    border-bottom: 1px solid rgba(87, 65, 52, 0.14);\n    color: var(--marketing-ink);\n    font-size: clamp(1.28rem, 5vw, 1.75rem);\n    font-weight: 700;\n    line-height: 1.2;\n    text-decoration: none;\n    transition: color 180ms cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    .mock-mobile-menu-nav a:hover {\n      color: var(--marketing-coral-dark);\n    }\n  }\n\n  .mock-mobile-menu-divider {\n    height: 1px;\n    margin: 26px 0 8px;\n    background: rgba(87, 65, 52, 0.18);\n  }\n\n  .mock-mobile-auth,\n  .mock-mobile-user {\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n\n  .mock-mobile-user {\n    display: none;\n  }\n\n  .mock-mobile-auth a,\n  .mock-mobile-user a {\n    font-size: clamp(1.12rem, 4.2vw, 1.42rem);\n    font-weight: 600;\n  }\n\n  .mock-footer-links {\n    width: 100%;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 28px 20px;\n  }\n\n  .mock-footer-group:last-child {\n    grid-column: 1 / -1;\n  }\n}\n\n/* Short landscape phone viewports should never leave the full-page menu in\n * its hidden transition frame while Safari is settling the viewport. */\n@media (orientation: landscape) and (max-height: 520px) {\n  .mock-mobile-menu {\n    transition: none;\n  }\n}\n\n@media (max-width: 620px) {\n  .mock-tagline {\n    font-size: 0.58rem;\n  }\n}\n\nhtml.mobile-menu-open {\n  overflow: hidden;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .mock-mobile-menu,\n  .mock-mobile-menu-toggle,\n  .mock-mobile-menu-close,\n  .mock-mobile-menu-nav a {\n    transition: none;\n  }\n\n  .mock-mobile-menu,\n  .mock-mobile-menu-nav a {\n    transform: none;\n  }\n}\n\n/*\n * Homepage hero direction.\n *\n * The interactive card preview remains the visual anchor. The copy side\n * carries only the promise, one sentence, two actions, and one quiet proof\n * line so the first viewport has a single readable path.\n */\n.homepage-mockup .mock-hero {\n  padding-top: clamp(24px, 3.8vw, 54px);\n}\n\n.homepage-mockup .mock-hero-copy {\n  align-self: center;\n}\n\n.homepage-mockup .mock-hero h1 {\n  max-width: 12.8ch;\n  font-size: clamp(2.95rem, 5.05vw, 5.05rem);\n  line-height: 0.94;\n  text-shadow: none;\n}\n\n.homepage-mockup .mock-hero-copy .lede {\n  max-width: 38ch;\n  margin-top: 22px;\n  line-height: 1.58;\n}\n\n.homepage-mockup .mock-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  max-width: 100%;\n  margin-top: 24px;\n}\n\n.homepage-mockup .mock-primary,\n.homepage-mockup .mock-secondary {\n  width: auto;\n  flex: 0 0 auto;\n}\n\n.homepage-mockup .mock-hero .mini-feature-row,\n.homepage-mockup .mock-hero .trust-row,\n.homepage-mockup .mock-hero .proof-snapshot {\n  display: none;\n}\n\n.homepage-mockup .mock-hero-proof {\n  max-width: 38ch;\n  margin: 17px 0 0;\n  color: var(--ink-muted);\n  font-size: 0.84rem;\n  line-height: 1.45;\n}\n\n/* Keep the hero copy stable: the former animation began at opacity: 0. */\n.homepage-mockup .motion-ready .mock-hero-copy {\n  animation: homepage-hero-settle 700ms cubic-bezier(0.16, 1, 0.3, 1) both;\n}\n\n@keyframes homepage-hero-settle {\n  from {\n    transform: translateY(10px);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 820px) {\n  .homepage-mockup .mock-hero .mock-secondary {\n    display: inline-flex;\n  }\n\n  .homepage-mockup .mock-actions {\n    max-width: 360px;\n  }\n}\n\n@media (max-width: 560px) {\n  .homepage-mockup .mock-actions {\n    align-items: stretch;\n    flex-direction: column;\n    max-width: 360px;\n  }\n\n  .homepage-mockup .mock-primary,\n  .homepage-mockup .mock-secondary {\n    width: 100%;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .homepage-mockup .motion-ready .mock-hero-copy {\n    animation: none;\n  }\n}\n\n/*\n * Homepage how-it-works direction.\n *\n * Keep the illustration-led story, but make the steps feel like one editorial\n * sequence instead of four equal feature cards. The section heading is\n * intentionally direct: marketing pages do not need a decorative eyebrow.\n */\n.homepage-mockup .how-panel {\n  background: rgba(255, 253, 248, 0.58);\n}\n\n.homepage-mockup .how-panel .mock-section {\n  padding-top: clamp(72px, 8vw, 112px);\n  padding-bottom: clamp(84px, 9vw, 126px);\n}\n\n.homepage-mockup .how-panel .how-grid {\n  grid-template-columns: minmax(200px, 0.34fr) minmax(0, 1fr);\n  gap: clamp(42px, 6vw, 90px);\n  align-items: end;\n}\n\n.homepage-mockup .how-panel .how-grid > picture {\n  display: block;\n  align-self: end;\n}\n\n.homepage-mockup .how-panel .postwoman {\n  width: min(280px, 100%);\n  margin: 0;\n}\n\n.homepage-mockup .how-panel .templates-head {\n  max-width: 58rem;\n  margin: 0;\n  text-align: left;\n}\n\n.homepage-mockup .how-panel .templates-head h2 {\n  max-width: 13ch;\n  margin-top: 0;\n  font-size: clamp(2.55rem, 4.1vw, 4.55rem);\n  line-height: 0.98;\n  text-wrap: balance;\n}\n\n.homepage-mockup .how-panel .templates-head p {\n  max-width: 48ch;\n  margin: 16px 0 0;\n}\n\n.homepage-mockup .how-panel .step-track {\n  position: relative;\n  --how-step-art-width: 170px;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: clamp(18px, 2.8vw, 36px);\n  margin-top: clamp(40px, 4.8vw, 60px);\n}\n\n.homepage-mockup .how-panel .step-track::before {\n  position: absolute;\n  top: 0.68rem;\n  right: 0;\n  left: 0;\n  height: 1px;\n  background: linear-gradient(90deg, rgba(201, 71, 80, 0.16), rgba(201, 71, 80, 0.36) 50%, rgba(201, 71, 80, 0.16));\n  content: \"\";\n}\n\n.homepage-mockup .how-panel .step-card {\n  min-height: 0;\n  padding: 0;\n  gap: 16px;\n}\n\n.homepage-mockup .how-panel .step-number {\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  width: auto;\n  height: auto;\n  min-width: 0;\n  align-items: center;\n  justify-content: center;\n  justify-self: center;\n  margin-left: 0;\n  padding: 0 0.48rem;\n  border-radius: 0;\n  background: rgba(255, 253, 248, 0.94);\n  box-shadow: 0 0 0 5px rgba(255, 253, 248, 0.72);\n  color: var(--coral-dark);\n  font-family: var(--display);\n  font-size: 1.35rem;\n  font-weight: 400;\n  line-height: 1;\n}\n\n.homepage-mockup .how-panel .step-art {\n  display: flex;\n  width: min(100%, var(--how-step-art-width));\n  height: auto;\n  aspect-ratio: 3 / 2;\n  min-height: 0;\n  max-height: none;\n  align-items: flex-end;\n  justify-content: center;\n  justify-self: center;\n  overflow: visible;\n  position: static;\n  background: transparent;\n}\n\n.homepage-mockup .how-panel .step-art picture {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.homepage-mockup .how-panel .step-art img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  object-position: center bottom;\n}\n\n.homepage-mockup .how-panel .step-card > div:last-child {\n  width: min(100%, var(--how-step-art-width));\n  max-width: var(--how-step-art-width);\n  justify-self: center;\n}\n\n.homepage-mockup .how-panel .step-card h3 {\n  margin: 0;\n  color: var(--ink);\n  font-size: 1.08rem;\n  font-weight: 800;\n  line-height: 1.28;\n  text-align: left;\n}\n\n.homepage-mockup .how-panel .step-card p {\n  max-width: 22ch;\n  margin: 8px 0 0;\n  color: var(--ink-soft);\n  font-size: 0.95rem;\n  line-height: 1.55;\n  text-align: left;\n}\n\n/* The process remains visible while it enters the viewport. This avoids a\n * blank section during a fast scroll or when the observer initializes late. */\n.homepage-mockup .how-panel .motion-reveal,\n.homepage-mockup .how-panel .motion-reveal.is-visible {\n  opacity: 1;\n  transform: none;\n  transition: none;\n  transition-delay: 0ms;\n  will-change: auto;\n}\n\n.homepage-mockup .motion-ready .how-panel .step-card.is-visible .step-number {\n  animation: none;\n}\n\n@media (max-width: 1120px) {\n  .homepage-mockup .how-panel .how-grid {\n    grid-template-columns: 1fr;\n    gap: 28px;\n  }\n\n  .homepage-mockup .how-panel .how-grid > picture {\n    justify-self: start;\n  }\n\n  .homepage-mockup .how-panel .postwoman {\n    display: block;\n    width: min(210px, 42vw);\n  }\n}\n\n@media (max-width: 820px) {\n  .homepage-mockup .how-panel .step-track {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .homepage-mockup .how-panel .step-track::before {\n    display: none;\n  }\n\n  .homepage-mockup .how-panel .step-number {\n    margin-left: 0;\n    padding: 0;\n    background: transparent;\n    box-shadow: none;\n  }\n}\n\n@media (max-width: 680px) {\n  .homepage-mockup .how-panel .mock-section {\n    padding-top: 64px;\n    padding-bottom: 78px;\n  }\n\n  .homepage-mockup .how-panel .postwoman {\n    width: min(190px, 48vw);\n    margin-inline: auto;\n  }\n\n  .homepage-mockup .how-panel .how-grid > picture {\n    justify-self: center;\n  }\n\n  .homepage-mockup .how-panel .templates-head {\n    text-align: center;\n  }\n\n  .homepage-mockup .how-panel .templates-head h2 {\n    max-width: 12ch;\n    margin-inline: auto;\n    font-size: clamp(2.35rem, 11vw, 3.5rem);\n  }\n\n  .homepage-mockup .how-panel .templates-head p {\n    margin-inline: auto;\n    text-align: center;\n  }\n\n  .homepage-mockup .how-panel .step-track {\n    --how-step-art-width: 360px;\n    grid-template-columns: 1fr;\n    gap: 46px;\n    margin-top: 38px;\n  }\n\n  .homepage-mockup .how-panel .step-card {\n    grid-template-columns: minmax(0, 1fr);\n    row-gap: 12px;\n  }\n\n  .homepage-mockup .how-panel .step-card:not(:last-child)::before {\n    display: none;\n  }\n\n  .homepage-mockup .how-panel .step-number {\n    grid-column: 1;\n    grid-row: 1;\n    align-self: start;\n    margin: 0;\n    padding: 0;\n    background: transparent;\n    box-shadow: none;\n  }\n\n  .homepage-mockup .how-panel .step-art {\n    grid-column: 1;\n    grid-row: 2;\n    width: min(100%, var(--how-step-art-width));\n    height: auto;\n    aspect-ratio: 3 / 2;\n  }\n\n  .homepage-mockup .how-panel .step-card > div:last-child {\n    grid-column: 1;\n    grid-row: 3;\n    text-align: center;\n    justify-self: center;\n  }\n\n  .homepage-mockup .how-panel .step-card h3,\n  .homepage-mockup .how-panel .step-card p {\n    text-align: center;\n  }\n\n  .homepage-mockup .how-panel .step-card p {\n    margin-inline: auto;\n  }\n}\n\n@media (max-width: 420px) {\n  .homepage-mockup .how-panel .step-track {\n    --how-step-art-width: 330px;\n  }\n}\n\n/*\n * Homepage closing CTA direction.\n *\n * The last section is a calm handoff: one direct invitation, one primary\n * action, one quiet pricing link, and a single piece of card artwork. The\n * dark ink surface gives the closing moment a clear, quiet finish.\n */\n.homepage-mockup .mock-final {\n  grid-template-columns: minmax(300px, 0.96fr) minmax(280px, 1.04fr);\n  gap: clamp(32px, 6vw, 78px);\n  padding: clamp(44px, 6vw, 72px);\n  border-color: rgba(201, 71, 80, 0.22);\n  background: #e8a198;\n  color: var(--ink);\n  box-shadow: 0 14px 0 rgba(201, 71, 80, 0.12), 0 24px 46px rgba(84, 55, 44, 0.12);\n  overflow: hidden;\n}\n\n.homepage-mockup .mock-final > div:first-child {\n  max-width: 540px;\n}\n\n.homepage-mockup .mock-final .mock-eyebrow {\n  display: none;\n}\n\n.homepage-mockup .mock-final h2 {\n  max-width: 13ch;\n  margin-top: 0;\n  color: #fffaf9;\n  font-size: clamp(2.55rem, 4.6vw, 4.7rem);\n  line-height: 0.96;\n  text-wrap: balance;\n}\n\n.homepage-mockup .mock-final > div:first-child > p:not(.mock-eyebrow) {\n  max-width: 39ch;\n  margin-top: 20px;\n  color: rgba(48, 42, 39, 0.76);\n  line-height: 1.58;\n}\n\n.homepage-mockup .mock-final .mock-actions {\n  margin-top: 28px;\n}\n\n.homepage-mockup .mock-final .mock-secondary {\n  display: inline-flex;\n  min-height: auto;\n  border: 0;\n  border-bottom: 1px solid rgba(48, 42, 39, 0.42);\n  border-radius: 0;\n  background: transparent;\n  color: var(--ink);\n  padding: 5px 0 3px;\n  font-weight: 700;\n}\n\n.homepage-mockup .mock-final .mock-secondary:hover {\n  border-bottom-color: var(--ink);\n  background: transparent;\n  box-shadow: none;\n}\n\n.homepage-mockup .mock-final .mock-primary {\n  border-color: var(--cream);\n  background: var(--cream);\n  color: var(--ink);\n}\n\n.homepage-mockup .mock-final .mock-primary:hover {\n  border-color: var(--cream);\n  background: var(--cream);\n  color: var(--ink);\n}\n\n/* Keep the closing invitation present; it should never blink in on scroll. */\n.homepage-mockup .mock-final .motion-reveal,\n.homepage-mockup .mock-final .motion-reveal.is-visible {\n  opacity: 1;\n  transform: none;\n  transition: none;\n  transition-delay: 0ms;\n  will-change: auto;\n}\n\n.homepage-mockup .mock-final-art {\n  min-height: 250px;\n  display: grid;\n  place-items: center end;\n}\n\n.homepage-mockup .mock-final-art picture {\n  display: block;\n  width: min(100%, 560px);\n}\n\n.homepage-mockup .mock-final-art img {\n  display: block;\n  width: 100%;\n  height: auto;\n  mix-blend-mode: normal;\n  opacity: 1;\n  transform: none;\n  filter: none;\n}\n\n@media (max-width: 1120px) {\n  .homepage-mockup .mock-final {\n    grid-template-columns: 1fr;\n  }\n\n  .homepage-mockup .mock-final-art {\n    min-height: 190px;\n    place-items: center;\n  }\n\n  .homepage-mockup .mock-final-art img {\n    width: 100%;\n  }\n\n  .homepage-mockup .mock-final-art picture {\n    width: min(100%, 430px);\n  }\n}\n\n@media (max-width: 560px) {\n  .homepage-mockup .mock-final {\n    padding: 40px 28px 34px;\n  }\n\n  .homepage-mockup .mock-final h2 {\n    max-width: 12ch;\n    font-size: clamp(2.4rem, 11vw, 3.6rem);\n  }\n\n  .homepage-mockup .mock-final .mock-secondary {\n    width: fit-content;\n    align-self: flex-start;\n  }\n\n  .homepage-mockup .mock-final-art {\n    min-height: 160px;\n    margin-top: 8px;\n  }\n\n  .homepage-mockup .mock-final-art img {\n    width: 100%;\n  }\n\n  .homepage-mockup .mock-final-art picture {\n    width: min(100%, 320px);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .homepage-mockup .mock-final .motion-reveal,\n  .homepage-mockup .mock-final .motion-reveal.is-visible {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
